

























import Vue from 'vue';

import { CrashReport, CrashReportAction } from '@/services/App';

import ErrorInfoModal from '@/components/modals/ErrorInfoModal.vue';

export default Vue.extend({
    computed: {
        crashReport(): CrashReport {
            return this.$app.crashReport!;
        },
        actions(): CrashReportAction[] {
            const actions: CrashReportAction[] = [
                {
                    label: 'Reload the page',
                    priority: 1,
                    handle: () => location.reload(),
                },
                {
                    label: 'View error details',
                    priority: 1,
                    handle: () => this.$ui.openModal(ErrorInfoModal, { error: this.crashReport.error }),
                },
            ];

            if (this.$auth.loggedIn) {
                actions.push({
                    label: 'Logout',
                    priority: 1,
                    handle: async () => {
                        await this.$auth.logout();

                        this.$app.clearCrashReport();
                    },
                });
            }

            actions.push(
                ...this.crashReport.actions.map(
                    action => ({
                        priority: 2,
                        ...action,
                    }),
                ),
            );

            actions.sort((a, b) => b.priority! - a.priority!);

            return actions;
        },
    },
});
